import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1dc4b660"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "card" };
var _hoisted_2 = { class: "card-img" };
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = { class: "count" };
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("i", { class: "iconfont icon_shipin_bofangshu" }, null, -1); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("i", { class: "iconfont icon_shipin_danmushu" }, null, -1); });
var _hoisted_7 = { class: "title" };
// 父传子需要通过 defineProps 接收
// PropType 用于指定格式
export default /*#__PURE__*/ _defineComponent({
    __name: 'app-video-item',
    props: {
        video: {
            // Object 对象为 IVideoItem 接口格式
            // 需要定义这个接口类型，所以需要导入ProType
            type: Object,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createBlock(_component_router_link, {
                class: "v-card",
                to: "/video/".concat(__props.video.id)
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("img", {
                                class: "pic",
                                src: __props.video.imgSrc,
                                alt: __props.video.desc
                            }, null, 8, _hoisted_3)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", null, [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(__props.video.playCount), 1)
                            ]),
                            _createElementVNode("span", null, [
                                _hoisted_6,
                                _createTextVNode(" " + _toDisplayString(__props.video.commentCount), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(__props.video.desc), 1)
                ]; }),
                _: 1
            }, 8, ["to"]));
        };
    }
});
